import { ClinicInformationRequest } from 'src/models/clinic';
import { ProviderInfoPayment } from 'src/models/provider';
import RootState from 'src/modules/rootState';

export class Action {
    type: string;
    clinicInformation: ClinicInformationRequest;
    isPass: boolean;

    //error
    statusCode?: number;
    errorMessage: string;
    
}

export interface State {
    saving: boolean;
    saved: boolean;
    isPass: boolean;

    // error
    statusCode?: number;
    errorMessage: string;

    provider: ProviderInfoPayment;
}

export const types = {
    ADD_CLINIC_INFORMATION_ASYNC: 'ADD_CLINIC_INFORMATION_ASYNC',
    ADD_CLINIC_INFORMATION_SUCCEED: 'ADD_CLINIC_INFORMATION_SUCCEED',
    ADD_CLINIC_INFORMATION_FAILED: 'ADD_CLINIC_INFORMATION_FAILED',

    STORE_PROVIDER_INFORMATION_PAYMENT_WITH_CLINIC: 'STORE_PROVIDER_INFORMATION_PAYMENT_WITH_CLINIC',
    UPDATE_STATUS_CODE: 'UPDATE_STATUS_CODE'
};

const baseAction = new Action();

export const actions = {
    addClinicInformationAsync: (clinicInformation: ClinicInformationRequest): Action => ({
        ...baseAction,
        type: types.ADD_CLINIC_INFORMATION_ASYNC,
        clinicInformation
    }),

    addClinicInformationSucceeded: (isPass: boolean): Action => ({
        ...baseAction,
        type: types.ADD_CLINIC_INFORMATION_SUCCEED,
        isPass
    }),

    addClinicInformationFailed: (errorMessage: string): Action => ({
        ...baseAction,
        type: types.ADD_CLINIC_INFORMATION_FAILED,
        errorMessage: errorMessage
    }),

    storeProviderInformationPaymentWithClinic: (clinicInformation: ClinicInformationRequest): Action => ({
        ...baseAction,
        type: types.STORE_PROVIDER_INFORMATION_PAYMENT_WITH_CLINIC,
        clinicInformation
    }),

    updateStatusCode: (statusCode?: number): Action => ({
        ...baseAction,
        type: types.UPDATE_STATUS_CODE,
        statusCode
    }),
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.clinicData,
    saving(rootState: RootState): boolean {
        const { saving } = this.getState(rootState);
        return saving;
    },

    saved(rootState: RootState): boolean {
        const { saved } = this.getState(rootState);
        return saved;
    },
    isPass(rootState: RootState): boolean {
        const { isPass } = this.getState(rootState);
        return isPass;
    },
    getProviderInformationPayment(rootState: RootState): ProviderInfoPayment {
        const { provider } = this.getState(rootState);
        return provider;
    },
};


// WEBPACK FOOTER //
// ./src/modules/entities/clinic/index.ts